module.exports = "<div class=\"container-fluid\" dynamicPage>\r\n    <router-outlet></router-outlet>\r\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/version/version.component.html
// module id = ./src/app/views/version/version.component.html
// module chunks = main